import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=1a925449&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=1a925449&prod&lang=css&"
import style1 from "./Orders.vue?vue&type=style&index=1&id=1a925449&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a925449",
  null
  
)

export default component.exports